import React, { useState, useEffect, Fragment } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { Image } from "react-bootstrap";
import { Container, Row, Table } from "react-bootstrap";
import BasicPagination from "../../../Pagination/Pagination";
import FiltersSection from "../../../superAdminComponents/superAdminAllComponent/superAdminVendorOrdersPrivate/FiltersSection";
import SubNavigationOrdersVendor from "../../../superAdminComponents/superAdminAllComponent/superAdminVendorOrdersPrivate/SubNavigationOrdersVendor";
import VendorOrderTablesBody, {
  VendorOrderTablesHead,
} from "../../../superAdminComponents/superAdminAllComponent/superAdminVendorOrdersPrivate/VendorOrderTables";
import Alert from "react-s-alert";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";
import { TopNavigationBarMobile } from "../../navigationSection/TopNavigationBarMobile";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import {
  get_all_order_vendor_side,
  edit_order_vendor_side,
  get_all_order_vendor_side_history,
  complete_all_orders,
  edit_order_vendor_v2,
} from "../../../../store/actions/OrderingAction/vendorOrderingAction";
import { get_current_restaurant_opening_status } from "../../../../store/actions/authAction";
import isEmpty from "../../../../store/validation/is-Empty";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import SocketContext from "../../../../function/SocketContext";

import SVG from "react-inlinesvg";
import {
  UPDATE_ORDER_DATA_SOCKET,
  SET_LOADER,
  CLEAR_LOADER,
} from "../../../../store/types";
import BottomNavigationMobile from "../../navigationSection/BottomNavigationMobile";
import Media from "react-media";
import Accordion from "react-bootstrap/Accordion";
import VendorOrderTablesBodyMobile from "./VendorOrderTablesBodyMobile";
//import { NewInputText } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { TextField } from "@material-ui/core";
import moment from "moment";
import store from "../../../../store/store";
import {
  CLEAR_CART_DATA,
  CLEAR_CART_DATA_USER_DATA,
} from "../../../../store/types";
import SelectFilter from "../../../reusableComponents/selectFilter";
import NoContent from "../../../reusableComponents/NoContentComponent";
import SubnavigatorMobilepwa from "../../../superAdminComponents/superAdminAllComponent/superAdminVendorOrdersPrivate/SubnavigatorMobilepwa";

export const OrderDashboardScreen = (props) => {
  //State
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const [state, setState] = useState({
    orderType: history?.location?.pathname.split("/")?.[2]
      ? parseInt(history?.location?.pathname.split("/")?.[2])
      : 10,
    orderStatus: 10,
    orderTypeStatus: 10,
    orderProcessingTime: 8,
    orderProcessingStatus: 8,
  });

  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);

  const handleBatchChange = (pageNo) => {
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };
  const [showSkipTheLine, setShowSkipTheLine] = useState(false);
  const [showHomeDelivery, setShowHomeDelivery] = useState(false);
  const [showTakeAway, setShowTakeAway] = useState(true);
  const [showCurbSide, setShowCurbSide] = useState(false);
  const [showDineIn, setShowDineIn] = useState(false);
  const [onSetDate, selectOnSetDate] = useState();
  const [selectedDate, setSelectedDate] = useState();

  const [orderTypeFilter, setOrderType] = useState(10);
  const [paymentTypeFilter, setPaymentType] = useState(10);
  const [paymentStatusFilter, setPaymentStatus] = useState(10);
  const [marktype, setMarktype] = useState();

  const [scanData, setScanData] = useState({
    scanData: {},
    scanComplete: false,
  });

  const [dateQuery, setDateQuery] = useState({});

  const onDateChangeHandler = (data, type) => {
    // console.log("data", data);
    setDateQuery(data);
    // getReportData("", data);
  };

  useEffect(() => {
    if (
      props?.match?.params?.page
      // parseInt(props?.match?.params?.page) !== state?.orderType
    ) {
      onActionClick(parseInt(props?.match?.params?.page) || 10);
    }
  }, [props?.match?.params?.page]);

  const calcDate = () => {
    return props.orderDetails?.later_date || props.orderDetails?.createdAt;
  };

  useEffect(() => {
    if (history.location?.state?.type) {
      onActionClick(history.location?.state?.type)();
    }
  }, [history.location?.state]);

  useEffect(() => {
    let finalDate = moment().format("YYYY-MM-DD");
    selectOnSetDate(finalDate);
    setSelectedDate(finalDate);
  }, []);

  const onChangeDate = (date) => {
    selectOnSetDate(date);
  };

  const onClickSetSelectedDateClick = () => {
    // console.log("OnSetDate", onSetDate);
    setSelectedDate(onSetDate);
  };

  const onSuccessAction = (e) => {
    const token = props.auth?.user?.accessToken;
    dispatch(
      get_all_order_vendor_side(
        token,
        state.orderType,
        state.orderStatus,
        new Date(selectedDate).getTime()
      )
    );
  };

  const onSuccesshistory = () => {
    setState({
      ...state,
      orderType: 20,
      orderStatus: 10,
      orderProcessingTime: 8,
      orderProcessingStatus: 8,
    });
    history.push(`/orderdashboard/${20}`);
  };

  const onActionClick = (type) => (e) => {
    setMarktype(type);
    setOrderType(10);
    setPaymentType(10);
    setPaymentStatus(10);
    const token = props?.auth?.user?.accessToken;

    if (type === 20) {
      onSuccesshistory();
      // dispatch(get_all_order_vendor_side_history(token, dateQuery, onSuccesshistory)); // this is for history order staus
    } else {
      if (type === 11) {
        onChangeOrderStatus(0);
        dispatch(
          get_all_order_vendor_side(
            token,
            10,
            0,
            new Date(selectedDate).getTime(),
            (order_type, order_status) =>
              onSuccess(order_type, order_status, type)
          )
        ); // this is for pending order staus
      } else {
        dispatch(
          get_all_order_vendor_side(
            token,
            type,
            10,
            new Date(selectedDate).getTime(),
            (order_type, order_status) =>
              onSuccess(order_type, order_status, type)
          )
        );
      }
    }
  };

  const onSuccess = (order_type, order_status, type) => {
    if (order_status === 10) {
      setState({
        ...state,
        orderType: order_type,
        orderStatus: order_status,
      });
    } else if (order_status === 0) {
      setState({
        ...state,
        orderType: 11,
        orderStatus: 0,
      });
    } else {
      setState({
        ...state,
        orderType: 11,
        orderStatus: 11,
      });
    }
    setPage(1);
    setStart(0);
    setEnd(10);
    history.push(`/orderdashboard/${type}`);
  };

  // const allOrderData = useSelector((state) => {
  //   return !isEmpty(state.vendorOrdering) &&
  //     !isEmpty(state.vendorOrdering.vendor_get_all_takeaway_order)
  //     ? state.vendorOrdering.vendor_get_all_takeaway_order
  //     : "";
  // });

  const checkRestaurantOpen = () => {
    let token = props?.auth?.user?.accessToken;
    // if (
    //   props &&
    //   props.onboarding &&
    //   props.onboarding.sessionSettings &&
    //   props.onboarding.sessionSettings.restaurant_open
    // ) {
    store.dispatch({ type: CLEAR_CART_DATA, payload: [] });
    store.dispatch({ type: CLEAR_CART_DATA_USER_DATA, payload: [] });
    dispatch(
      get_current_restaurant_opening_status(token, onSuccessOpen, (err) =>
        onError(err)
      )
    );

    // } else {
    //   Alert.error(
    //     `<h4>Cannot create order as restaurant is currently closed</h4>`,
    //     {
    //       position: "top-right",
    //       effect: "bouncyflip",
    //       beep: true,
    //       html: true,
    //       timeout: 3000,
    //       offset: 35,
    //     }
    //   );
    // }
  };

  const onSuccessOpen = () => {
    history.push("/addorder");
  };

  const onError = (err) => {
    Alert.error(`<h4>${err?.response?.data?.message}</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  const onChangeOrderStatus = (id, orderType) => {
    if (location.pathname === "/orderdashboard/10") {
      // console.log("All Order Dashboard ===>");
      setState({ ...state, orderStatus: id, orderTypeStatus: orderType });
    } else {
      setState({ ...state, orderStatus: id });
    }
  };
  const onChangeOrderProcessing = (data) => {
    setState({
      ...state,
      orderProcessingTime: data.value,
      orderProcessingStatus: data.id,
    });
  };

  var filtereddata = [];
  const renderOrderTablesBodyMobile = () => {
    if (
      orderTypeFilter === 10 &&
      paymentTypeFilter === 10 &&
      paymentStatusFilter === 10
    ) {
      filtereddata = allOrderData;
    }
    if (orderTypeFilter !== 10) {
      filtereddata = allOrderData.filter((order) => {
        return order && order.order_type === orderTypeFilter;
      });
    }
    if (paymentTypeFilter !== 10) {
      filtereddata = allOrderData.filter((order) => {
        return order && order.payment_method === paymentTypeFilter;
      });
    }
    if (paymentStatusFilter !== 10) {
      filtereddata = allOrderData.filter((order) => {
        return order && order.payment_status === paymentStatusFilter;
      });
    }
    if (state.orderStatus !== 10) {
      filtereddata = filtereddata.filter((order) => {
        return order?.order_status === state.orderStatus;
      });
    }
    if (state.orderProcessingStatus !== 8) {
      filtereddata = filtereddata.filter((order) => {
        for (let i = 0; i < order.order_items.length; i++) {
          return (
            order?.order_items[i]?.item?.prepTime === state.orderProcessingTime
          );
        }
      });
    }

    if (search) {
      let searchData = new RegExp(search, "i");
      filtereddata = allOrderData.filter((getall) => {
        if (
          searchData.test(
            getall?.user_details?.first_name +
              " " +
              getall?.user_details?.last_name
          )
        ) {
          return getall;
        } else if (searchData.test(getall?.order_id)) {
          return getall;
        } else if (
          searchData.test(
            getall?.user_details?.country_code +
              " " +
              getall?.user_details?.mobile_number
          )
        ) {
          return getall;
        } else {
          return false;
        }
      });
    }

    if (!isEmpty(filtereddata)) {
      return filtereddata.slice(start, end).map((data, index) => {
        return (
          <React.Fragment key={index}>
            <VendorOrderTablesBodyMobile
              orderDetails={data}
              scanData={scanData?.scanData}
              indexKey={index}
              onUpdateOrderStatus={(formData) => onUpdateOrderStatus(formData)}
              onUpdateOrderStatusV2={(formData) => onUpdateOrderStatusV2(formData)}
              getUpdatedData={() => getUpdatedData()}
              type={marktype}
            />
          </React.Fragment>
        );
      });
    }
  };

  const renderOrderTablesBody = () => {
    if (
      orderTypeFilter === 10 &&
      paymentTypeFilter === 10 &&
      paymentStatusFilter === 10
    ) {
      filtereddata = allOrderData;
    }
    if (orderTypeFilter !== 10) {
      filtereddata = allOrderData.filter((order) => {
        return order && order.order_type === orderTypeFilter;
      });
    }
    if (paymentTypeFilter !== 10) {
      filtereddata = allOrderData.filter((order) => {
        return order && order.payment_method === paymentTypeFilter;
      });
    }
    if (paymentStatusFilter !== 10) {
      filtereddata = allOrderData.filter((order) => {
        return order && order.payment_status === paymentStatusFilter;
      });
    }
    if (state.orderStatus !== 10) {
      filtereddata = filtereddata.filter((order) => {
        if (location.pathname === "/orderdashboard/10") {
          return (
            // order?.order_type === state.orderTypeStatus ||
            order?.order_status === state.orderStatus
          );
        } else {
          return order?.order_status === state.orderStatus;
        }
      });
    }
    if (state.orderProcessingStatus !== 8) {
      filtereddata = filtereddata.filter((order) => {
        for (let i = 0; i < order.order_items.length; i++) {
          return (
            order?.order_items[i]?.item.prepTime === state.orderProcessingTime
          );
          // console.log(order.order_items[i].item);
        }
      });
    }

    if (search) {
      let searchData = new RegExp(search, "i");
      filtereddata = allOrderData.filter((getall) => {
        if (
          searchData.test(
            getall?.user_details?.first_name +
              " " +
              getall?.user_details?.last_name
          )
        ) {
          return getall;
        } else if (searchData.test(getall?.order_id)) {
          return getall;
        } else if (
          searchData.test(
            getall?.user_details?.country_code +
              " " +
              getall?.user_details?.mobile_number
          )
        ) {
          return getall;
        } else {
          return false;
        }
      });
    }

    if (!isEmpty(filtereddata)) {
      return (
        filtereddata &&
        filtereddata.slice(start, end).map((data, index) => {
          return (
            <React.Fragment key={index}>
              <VendorOrderTablesBody
                orderDetails={data}
                scanData={scanData?.scanData}
                onUpdateOrderStatus={(formData) =>
                  onUpdateOrderStatus(formData)
                }
                onUpdateOrderStatusV2={(formData) => onUpdateOrderStatusV2(formData)}
                getUpdatedData={() => getUpdatedData()}
              />
            </React.Fragment>
          );
        })
      );
    }
  };

  const [allOrderData, setAllVendorData] = useState([]);
  const [search, setSearch] = useState("");

  const onChangeSearch = (e) => {
    if (e === "all" || e === "remove" || e === "clear") {
      setSearch("");
    } else if (search !== e) {
      setSearch(e);
    } else {
      setSearch("");
    }
  };

  const onSuccessChangeStatus = () => {
    getUpdatedData();
  };

  const onUpdateOrderStatus = (formData) => {
    const token = props?.auth?.user?.accessToken;
    dispatch(edit_order_vendor_side(token, formData, onSuccessChangeStatus));
  };
  
  const onUpdateOrderStatusV2 = (formData) => {
    const token = props?.auth?.user?.accessToken;
    dispatch(edit_order_vendor_v2(token, formData, onSuccessChangeStatus));
  };
  

  useEffect(() => {
    const token = props?.auth?.user?.accessToken;
    if (selectedDate) {
      if (state.orderType === 20) {
        onSuccesshistory();
        // dispatch(get_all_order_vendor_side_history(token, dateQuery, onSuccesshistory)); // this is for history order staus
      } else {
        if (state.orderType === 11) {
          onChangeOrderStatus(0);
          dispatch(
            get_all_order_vendor_side(
              token,
              10,
              0,
              new Date(selectedDate).getTime(),
              (order_type, order_status) =>
                onSuccess(order_type, order_status, state.orderType)
            )
          ); // this is for pending order staus
        } else {
          dispatch(
            get_all_order_vendor_side(
              token,
              state.orderType,
              10,
              new Date(selectedDate).getTime(),
              (order_type, order_status) =>
                onSuccess(order_type, order_status, state.orderType)
            )
          );
        }
      }
    }
  }, [get_all_order_vendor_side, selectedDate]);

  useEffect(() => {
    if (!isEmpty(dateQuery)) {
      dispatch(
        get_all_order_vendor_side_history(
          props?.auth?.user?.accessToken,
          dateQuery,
          () => {}
        )
      );
    }
  }, [dateQuery]);

  const getUpdatedData = () => {
    const token = props?.auth?.user?.accessToken;
    dispatch(
      get_all_order_vendor_side(
        token,
        state.orderType,
        state.orderStatus,
        new Date(selectedDate).getTime(),
        onSuccessAction
      )
    );
  };

  const getMarkAll = () => {
    const token = props?.auth?.user?.accessToken;
    const formData = {
      markAllComplete: true,
    };
    dispatch(complete_all_orders(token, formData, getUpdatedData));
  };

  useEffect(() => {
    if (
      props.servicesEnabled &&
      props.servicesEnabled.self_serve &&
      props.servicesEnabled.self_serve.value
    ) {
      setShowSkipTheLine(true);
    }
    if (
      props.servicesEnabled &&
      props.servicesEnabled.cubside_delivery &&
      props.servicesEnabled.cubside_delivery.value
    ) {
      setShowCurbSide(true);
    }
    if (
      props.servicesEnabled &&
      props.servicesEnabled.dine_in_order &&
      props.servicesEnabled.dine_in_order.value
    ) {
      setShowDineIn(true);
    }
    if (
      props.servicesEnabled &&
      props.servicesEnabled.home_delivery &&
      props.servicesEnabled.home_delivery.value
    ) {
      setShowHomeDelivery(true);
    }
  }, [props?.servicesEnabled]);

  useEffect(() => {
    if (props?.allOrderDataa === "") {
      dispatch({ type: SET_LOADER });
    } else {
      dispatch({ type: CLEAR_LOADER });
      setAllVendorData(props?.allOrderDataa);
    }
  }, [props?.allOrderDataa]);

  useEffect(() => {
    setPage(1);
    setStart(0);
    setEnd(10);
  }, [search]);

  useEffect(() => {
    props.socket.service("ordering").on("order_trigger", (data) => {
      if (data.order_status !== 9) {
        dispatch({
          type: UPDATE_ORDER_DATA_SOCKET,
          payload: data,
        });
      }
    });

    //this event will trigger on creating a new diner request
    props.socket.service("ordering").on("order_creation", (data) => {
      if (data?.order_status !== 9) {
        dispatch({
          type: UPDATE_ORDER_DATA_SOCKET,
          payload: data,
        });
      }
    });
  }, []);

  const onSuccessScan = (data) => {
    setScanData({ scanData: data, scanComplete: true });
  };

  const [displayDropDown, setdisplayDropDown] = useState(true);
  const onNextHoursOpen = () => setdisplayDropDown(!displayDropDown);

  try {
    return (
      <React.Fragment>
        {props?.auth?.loader || props?.auth?.secondary_loader ? (
          <AmealioLoader />
        ) : (
          <div className="container-fluid superadmin-orderscomponent-main super-admin-vendor-private-orders" style={{fontFamily:"Roboto "}}>
            <Row>
              <Media query="(min-width: 992px)">
                <div className="left-side-panel">
                  <LeftSideNavigation />
                </div>
              </Media>
              <div className="top-panel">
                <TopNavigationBarMobile />
              </div>
              <div className="right-side-panel">
                <RightSideNavigation
                  displayButton="buttonDisplayByChild"
                  // buttonDisplayByChild={
                  //   <NavLink
                  //     to="/addorder"
                  //     className="btn btn-danger text-normal btn-xs rounded"
                  //   >
                  //     + Add Order
                  //   </NavLink>
                  // }
                  {...(props.auth?.user?.VendorUser?.role === "superadmin"
                    ? {
                        leftText: "AllSeatingDashboard",
                      }
                    : {})}
                />
                <Container fluid>
                  <div className="super-admin-inside-right-side-panel">
                    <div className="seating_dashboard_top_new_header">
                      <Media query="(max-width: 992px)">
                        <div className="pwa-OP-font mt-3 mb-4">
                          Ordering Dashboard {" "}
                        </div>
                      </Media>
                      <Media query="(min-width: 992px)">
                        <div className="row align-items-center">
                          <div className="col-6">
                            <h4>Ordering Process Dashboard</h4>
                          </div>

                          <div className="col-3 text-right">
                            {state.orderType !== 20 &&
                            state.orderType !== 11 ? (
                              <>
                                <TopDateField
                                  date={onSetDate}
                                  changeDate={(date) => onChangeDate(date)}
                                  onButtonClickSetDate={() =>
                                    onClickSetSelectedDateClick()
                                  }
                                />
                              </>
                            ) : (
                              <> </>
                            )}
                          </div>

                          <div className="col-3 text-right">
                            <button
                              //onClick={(e) => history.push("/addorder")}
                              onClick={(e) => checkRestaurantOpen()}
                              className="btn"
                            >
                              <Image
                                alt="add"
                                title="add"
                                width="48px"
                                fluid
                                src={require("../../../../assets/images/seatingImages/add-button.svg")}
                              />
                              {/* + Create Order */}
                            </button>
                          </div>
                        </div>
                      </Media>
                    </div>
                     <Media query="(min-width: 992px)"> 
                    <SubNavigationOrdersVendor
                      orderType={state.orderType}
                      onActionClick={onActionClick}
                      dine_in={showDineIn}
                      curb_side={showCurbSide}
                      take_away={showTakeAway}
                      skip_line={showSkipTheLine}
                      home_delivery={showHomeDelivery}
                      
                    />
                    </Media> 
                  
                   <Media query="(max-width: 992px)">
                      <SubnavigatorMobilepwa
                      orderType={state.orderType}
                      onActionClick={onActionClick}
                      dine_in={showDineIn}
                      curb_side={showCurbSide}
                      take_away={showTakeAway}
                      skip_line={showSkipTheLine}
                      home_delivery={showHomeDelivery}
                      />
                    </Media>


                     {/* <Media query="(max-width: 992px)">
                      <hr className="m-0" />
                    </Media>  */}
                    {/* <br /> */} 
                  
                     <FiltersSection
                      orderTypeTwo={state.orderType}
                      onboarding={props.onboarding}
                      onSearchParent={(search) => onChangeSearch(search)}
                      onChangeOrderStatus={(id, orderType) =>
                        onChangeOrderStatus(id, orderType)
                      }
                      onChangeOrderProcessing={(data) =>
                        onChangeOrderProcessing(data)
                      }
                      token={props.auth?.user?.accessToken}
                      getUpdatedData={() => getUpdatedData()}
                      getMarkAll={() => getMarkAll()}
                      // date={onSetDate}
                      // changeDate={(date) => onChangeDate(date)}
                      // onButtonClickSetDate={() => onClickSetSelectedDateClick()}
                      // getMarkAll={() => getMarkAll()}
                      orderType={(data) => {
                        setOrderType(data);
                      }}
                      paymentType={(data) => {
                        setPaymentType(data);
                      }}
                      paymentStatus={(data) => {
                        setPaymentStatus(data);
                      }}
                      type={marktype}
                      mobileDateFilter={
                        state.orderType !== 20 && state.orderType !== 11 ? (
                          <>
                            <TopDateField
                              date={onSetDate}
                              changeDate={(date) => onChangeDate(date)}
                              onButtonClickSetDate={() =>
                                onClickSetSelectedDateClick()
                              }
                            />
                            
                          </>
                        ) : (
                          <> </>
                        )
                      }
                      onSuccessScan={onSuccessScan}
                      pathname={location?.pathname}
                    />   
                        <Media query = "(max-width : 992px)">
                            {state.orderType === 20 && (
                              <div className="col-12">
                                <SelectFilter
                                  onDateChange={onDateChangeHandler}
                                  defaultSelected="THISWEEK"
                                />
                              </div>
                            )}
                            </Media>
                           
                    <Media query="(min-width: 991px)">
                      <div>
                        <div className="col-12 mb-4">
                          <div
                            className="seating-dashboard-next-hours"
                            style={{
                              marginTop: state.orderType !== 11 ? "-2%" : "",
                          // cursor: "pointer",
                            }}
                          >
                            <div className="col-3 p-0 d-flex ">
                              <div className=" col-12 col-md-6 mpr-6 mobile-p-1">
                              <h5
                                className="font_24_m mr-3 cursor overflow-auto"
                                onClick={onNextHoursOpen}
                              >
                                {state.orderType === 11
                                  ? "Pending"
                                  : state.orderType === 10
                                  ? "All"
                                  : state.orderType === 0
                                  ? "Take Away"
                                  : state.orderType === 1
                                  ? "Curb Side"
                                  : state.orderType === 2
                                  ? "Skip-The Line"
                                  : state.orderType === 3
                                  ? "Dine - In"
                                  : state.orderType === 7
                                  ? "Delivery"
                                  : state.orderType === 20
                                  ? "History"
                                  : ""}
                              </h5>
                              </div>
                              <h5
                                className="font_20_m c_red mr-3 cursor"
                                onClick={onNextHoursOpen}
                              >
                                With-in next hour
                              </h5>
                              <div
                                className="cursor"
                                // className="dropdown_box b_c_red"
                              >
                                {displayDropDown ? (
                                  <i
                                    className="fa fa-angle-up c_red"
                                    aria-hidden="true"
                                    onClick={onNextHoursOpen}
                                  ></i>
                                ) : (
                                  <i
                                    className="fa fa-angle-down c_red"
                                    aria-hidden="true"
                                    onClick={onNextHoursOpen}
                                  ></i>
                                )}
                              </div>
                            </div>
                            {state.orderType === 20 && (
                              <div col-3 ml-1>
                                <SelectFilter
                                  onDateChange={onDateChangeHandler}
                                  defaultSelected="THISWEEK"
                                />
                              </div>
                            )}
                        
                          </div>
                        </div>
                        <div className="col-12 today-date-dropdown-seating-dashboard">
                          <div>
                            <h4>Today, {moment().format("Do MMM YYYY")}</h4>
                          </div>
                          <div className="seating-dashboard-today-line">
                            <hr className="line" />
                          </div>
                        </div>
                        <div className="col-12 p-0  user-table-reusable-superadmin font_16_r">
                          <Table>
                            <thead>
                              <VendorOrderTablesHead />
                            </thead>

                            {displayDropDown && allOrderData.length ? (
                              renderOrderTablesBody()
                            ) : (
                              <NoContent />
                            )}
                          </Table>
                        </div>
                      </div>
                    </Media>
                  
                    <Media query="(max-width: 991px)">
                      <>
                        <div className="row seating-dashboard-table">
                          <div className="col-2 mpr-1 mobile-p-0">
                            <p className="f12-700 pl-3">
                              Order <br />
                              Type
                            </p>
                          </div>
                          <div className="col-3 mpl-1 mpr-1 mobile-p-0">
                            <p className="f12-700 pl-3">
                              Name / <br />
                              Request No.
                            </p>
                          </div>
                          <div className="col-2 mpl-1 mobile-p-0">
                            <p className="f12-700 pl-3">
                              No. <br />
                              Items
                            </p>
                          </div>
                          <div className="col-2 mpl-1 mobile-p-0">
                            <p className="f12-700">
                              Amount / <br />
                              Payment
                            </p>
                          </div>
                          <div className="col-3 mpl-1 ">
                            <p className="f12-700">
                              Order <br />
                              Reference
                            </p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12 p-0 order-table-body-mobile">
                            <Accordion>
                              {allOrderData.length > 0 ? (
                                renderOrderTablesBodyMobile()
                              ) : (
                                <NoContent />
                              )}
                              {/* {this.renderNewOpenIssuesAccordian()} */}
                            </Accordion>
                          </div>
                        </div>
                      </>
                    </Media>
                    {filtereddata?.length !== 0 ? (
                      <BasicPagination
                        //totalRecords={50}
                        totalRecords={filtereddata?.length}
                        limit={10}
                        batch={page}
                        onBatchChange={(e) => handleBatchChange(e)}
                      />
                    ) : (
                      <Fragment></Fragment>
                    )}
                  </div>
                </Container>
              </div>
              <Media query="(max-width: 991px)">
                <div className="bottom-panel">
                  <BottomNavigationMobile />
                </div>
              </Media>
            </Row>
          </div>
        )}
      </React.Fragment>
    );
  } catch (e) {
    console.log(e);
  }
};

OrderDashboardScreen.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  // servicesEnabled:
  //   state.onboarding.onboard_subscription_details.casual_dining_status &&
  //   state.onboarding.onboard_subscription_details.casual_dining_status.ordering,
  servicesEnabled: state?.onboarding?.onboard_subscription_details
    ?.fast_food_dining
    ? state?.onboarding?.onboard_subscription_details?.fast_food_dining_status
        ?.ordering
    : state?.onboarding?.onboard_subscription_details?.casual_dining
    ? state?.onboarding?.onboard_subscription_details?.casual_dining_status
        ?.ordering
    : state?.onboarding?.onboard_subscription_details
        ?.multi_service_business_status?.ordering,
  // servicesEnabled:
  //   state.onboarding &&
  //   state.onboarding.onboard_subscription_details &&
  //   state.onboarding.onboard_subscription_details.fast_food_dining
  //     ? state.onboarding.onboard_subscription_details
  //         ?.fast_food_dining_status &&
  //       state.onboarding.onboard_subscription_details?.fast_food_dining_status
  //         ?.ordering
  //     : state.onboarding.onboard_subscription_details?.casual_dining_status &&
  //       state.onboarding.onboard_subscription_details?.casual_dining_status
  //         ?.ordering,
  allOrderDataa: state.vendorOrdering?.vendor_get_all_takeaway_order,
  onboarding: state.onboarding?.restaurantDetails,
});

const OrderDashboard = (props) => (
  <SocketContext.Consumer>
    {(socket) => <OrderDashboardScreen {...props} socket={socket} />}
  </SocketContext.Consumer>
);

export default connect(mapStateToProps, {
  clear_all_errors,
  get_all_order_vendor_side,
  edit_order_vendor_side,
  get_all_order_vendor_side_history,
  complete_all_orders,
})(withRouter(OrderDashboard));

export const TopDateField = (props) => {
  const [minEndDate, setMinEndDate] = useState(
    moment().subtract(7, "days").format("YYYY-MM-DD")
  );
  try {
    return (
      <div
        className="d-flex align-items-center"
        //  style={{ borderRight: "1px solid #00000029" }}
      >
        <TextField
          className="calenderstd w-75"
          id="date"
          variant="outlined"
          type="date"
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            inputProps: { min: minEndDate },
          }}
          name="date"
          onChange={(e) => props.changeDate(e.target.value)}
          value={props.date}
        />
        <button
          type="button"
          className="enIconBtn bg-transparent mx-3"
          onClick={props.onButtonClickSetDate}
        >
          <SVG
            width="20px"
            height="15px"
            src={require("../../../../assets/images/UserManagement/right-arrow.svg")}
            alt="Enter"
            title="Enter"
          />
        </button>
      </div>
    );
  } catch (e) {
    console.log(e);
  }
};
